namespace $.$$ {
	export class $eve_app_page_components_chip extends $.$eve_app_page_components_chip {}
}
